module.exports = __webpack_public_path__ + "media/components/journeys/route-icons/Water-ec632bc11042ffc572ad3ae991ad540a.png";